import React, {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import * as emitter from '../../global/emitter';
import {Portal} from '../../util';

declare const collapse: {
    init: () => void;
};

type Props = {
    toggleExpandable: (e: React.KeyboardEvent<HTMLDivElement>, id: string) => void;
};

const Yotpo: React.FC<Props> = observer(({toggleExpandable}) => {
    const initRef = useRef(false);

    useEffect(() => {
        const abForceUpdate = async () => {};

        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', abForceUpdate);

        const scriptId = 'yotpo-widget-script';
        const timeoutId = setTimeout(() => {
            if (!document.getElementById(scriptId)) {
                const script = document.createElement('script');

                script.id = scriptId;
                script.type = 'text/javascript';
                script.defer = true;
                script.src = '//staticw2.yotpo.com/H8vQ6ytRf3Uo0eAAlJJh85FR61IeET7EXRvzKasQ/widget.js';

                const firstScript = document.getElementsByTagName('script')[0];

                firstScript.parentNode?.insertBefore(script, firstScript);
            }
        }, 1750);

        return () => {
            clearTimeout(timeoutId);
            emitter.eventEmitter.unsubscribe(emitter.EventType.AB, 'ab');
            const existingScript = document.getElementById(scriptId);

            if (existingScript) {
                existingScript.remove();
            }
        };
    }, []);

    useEffect(() => {
        if (!initRef.current && s.ready && !s.ps.is_caf) {
            initRef.current = true;
            collapse.init();
        }
    });

    if (!s.ready) {
        return null;
    }

    if (!s.ps.is_caf) {
        return (
            <div id="prod-reviews">
                <div
                    id="prod-reviews-click"
                    className="prod-sub-header toggle-bs"
                    role="button"
                    tabIndex={0}
                    data-bs-toggle="collapse"
                    data-bs-target="#yotpo-main"
                    aria-expanded={false}
                    aria-controls="yotpo-main"
                    onKeyDown={e => toggleExpandable(e, 'prod-reviews-click')}
                >
                    Customer Reviews
                </div>
                <div
                    id="yotpo-main"
                    className={`show collapse`}
                >
                    <div
                        className="yotpo yotpo-main-widget"
                        id="divYotpo"
                        data-product-id={s.prod.ProductID}
                        data-name={s.ui.product_title}
                        data-currency="$"
                        data-price={s.ui.price}
                        data-url={s.si.URL}
                        data-image-url={s.prod.CustomizationMethod > 1 ? `https://${Portal?.IMGDomain}/i/${s.prod.ProductID}_220_250.png` : `${s.prod.Image_Thumb}`}
                    />
                </div>
            </div>
        );
    }

    return null;
});

export default Yotpo;
